import { render, staticRenderFns } from "./UnismgBol2.vue?vue&type=template&id=d96522ba&scoped=true&"
import script from "./UnismgBol2.vue?vue&type=script&lang=js&"
export * from "./UnismgBol2.vue?vue&type=script&lang=js&"
import style0 from "./UnismgBol2.vue?vue&type=style&index=0&id=d96522ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96522ba",
  null
  
)

export default component.exports